"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _LoginProvider = require("./LoginProvider");
Object.keys(_LoginProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LoginProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _LoginProvider[key];
    }
  });
});